export interface ConsentState {
  consentGiven: boolean;
  lastUpdated: string | null;
  consentVersion: string;
}

export interface UserConsentResponse {
  consentGiven: boolean;
  lastUpdated: string;
  consentVersion: string;
  userId: string;
}

export interface SaveUserConsentPayload {
  consentGiven: boolean;
  lastUpdated?: string;
  consentVersion?: string;
}

export const CONSENT_VERSION = "1.0";

export const CONSENT_LOCAL_KEY = "wpx_workspace_cookie_consent";
